import React from 'react';
import { useUser } from '../userContext';
import StorageCleanupWidget from '../components/StorageCleanupWidget';
import AnalyticsWidget from '../components/AnalyticsWidget';
import FeedbackWidget from '../components/FeedbackWidget';
import { 
  CogIcon,
  ShieldCheckIcon, 
} from '@heroicons/react/24/outline';

const AdminDashboard = () => {
  const { userProfile } = useUser();

  return (
    <div className="min-h-screen" style={{
 
    }}>
      {/* Animated Background Pattern */}
      <div className="fixed inset-0 opacity-10 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 20% 50%, rgba(241, 196, 15, 0.3) 0%, transparent 50%),
                           radial-gradient(circle at 80% 20%, rgba(52, 152, 219, 0.3) 0%, transparent 50%),
                           radial-gradient(circle at 40% 80%, rgba(155, 89, 182, 0.3) 0%, transparent 50%)`,
          backgroundSize: '800px 800px',
          animation: 'pulse 4s ease-in-out infinite'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Enhanced Header */}
     

        {/* Analytics Dashboard - Enhanced Container */}
        <div className="mb-12">
          <div className="rounded-2xl p-1" style={{
            background: 'linear-gradient(135deg, rgba(241, 196, 15, 0.6), rgba(230, 126, 34, 0.6))',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4)'
          }}>
            <div className="rounded-xl" style={{
              background: 'rgba(52, 73, 94, 0.8)',
              backdropFilter: 'blur(10px)'
            }}>
              <AnalyticsWidget />
            </div>
          </div>
        </div>

        {/* User Feedback Management - Enhanced Container */}
        <div className="mb-12">
          <div className="rounded-2xl p-1" style={{
            background: 'linear-gradient(135deg, rgba(52, 152, 219, 0.6), rgba(155, 89, 182, 0.6))',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4)'
          }}>
            <div className="rounded-xl" style={{
              background: 'rgba(52, 73, 94, 0.8)',
              backdropFilter: 'blur(10px)'
            }}>
              <FeedbackWidget />
            </div>
          </div>
        </div>

        {/* Main Admin Sections - Enhanced Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Storage Cleanup Section - Enhanced */}
          <div className="space-y-8">
            <div className="rounded-2xl p-1" style={{
              background: 'linear-gradient(135deg, rgba(46, 204, 113, 0.6), rgba(39, 174, 96, 0.6))',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
            }}>
              <div className="rounded-xl" style={{
                background: 'rgba(52, 73, 94, 0.8)',
                backdropFilter: 'blur(10px)'
              }}>
                <StorageCleanupWidget />
              </div>
            </div>
          </div>

          {/* Administrative Tools - Enhanced */}
          <div className="space-y-8">
            {/* System Information - Enhanced */}
            <div className="rounded-2xl p-1" style={{
              background: 'linear-gradient(135deg, rgba(52, 152, 219, 0.6), rgba(41, 128, 185, 0.6))',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
            }}>
              <div className="studio-card rounded-xl p-6" style={{
                background: 'rgba(52, 73, 94, 0.8)',
                border: 'none',
                backdropFilter: 'blur(10px)'
              }}>
              <div className="flex items-center gap-2 mb-4">
                <CogIcon className="h-6 w-6" style={{color: '#F1C40F'}} />
                <h2 className="text-xl font-black tracking-wider" style={{
                  color: '#F1C40F',
                  textShadow: '1px 1px 0px #E67E22'
                }}>
                  🔧 SYSTEM INFO
                </h2>
              </div>
              
              <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="font-bold" style={{color: '#ECF0F1'}}>Environment:</span>
                  <span className="font-black" style={{color: '#F1C40F'}}>
                    {process.env.NODE_ENV || 'development'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="font-bold" style={{color: '#ECF0F1'}}>Firebase Project:</span>
                  <span className="font-black truncate ml-2" style={{color: '#F1C40F'}}>
                    {process.env.REACT_APP_FIREBASE_PROJECT_ID || 'Not Set'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="font-bold" style={{color: '#ECF0F1'}}>Admin User:</span>
                  <span className="font-black truncate ml-2" style={{color: '#F1C40F'}}>
                    {userProfile?.email}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="font-bold" style={{color: '#ECF0F1'}}>Access Level:</span>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold" style={{
                    background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
                    color: '#ECF0F1',
                    border: '1px solid #F1C40F',
                    textShadow: '1px 1px 0px #A93226'
                  }}>
                    SUPER ADMIN
                  </span>
                </div>
              </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="rounded-2xl p-1" style={{
              background: 'linear-gradient(135deg, rgba(155, 89, 182, 0.6), rgba(142, 68, 173, 0.6))',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
            }}>
              <div className="studio-card rounded-xl p-6" style={{
                background: 'rgba(52, 73, 94, 0.8)',
                border: 'none',
                backdropFilter: 'blur(10px)'
              }}>
                <h2 className="text-xl font-black tracking-wider mb-4" style={{
                  color: '#F1C40F',
                  textShadow: '1px 1px 0px #E67E22'
                }}>
                  ⚡ QUICK ACTIONS
                </h2>
                
                <div className="space-y-3">
                  <button 
                    className="retro-button w-full text-left p-3 rounded-lg transition-all duration-100 hover:shadow-md"
                    style={{
                      background: 'rgba(52, 73, 94, 0.6)',
                      border: '1px solid rgba(241, 196, 15, 0.4)'
                    }}
                    onClick={() => window.open('/studio/campaigns', '_blank')}
                  >
                    <div className="font-black" style={{color: '#ECF0F1'}}>📋 View All Campaigns</div>
                    <div className="text-sm font-bold" style={{color: '#F1C40F'}}>
                      Access all user campaigns across the system
                    </div>
                  </button>

                  <button 
                    className="retro-button w-full text-left p-3 rounded-lg transition-all duration-100 hover:shadow-md"
                    style={{
                      background: 'rgba(52, 73, 94, 0.6)',
                      border: '1px solid rgba(241, 196, 15, 0.4)'
                    }}
                    onClick={() => window.open('https://console.firebase.google.com', '_blank')}
                  >
                    <div className="font-black" style={{color: '#ECF0F1'}}>🔥 Firebase Console</div>
                    <div className="text-sm font-bold" style={{color: '#F1C40F'}}>
                      Access Firebase project management
                    </div>
                  </button>

                  <button 
                    className="retro-button w-full text-left p-3 rounded-lg transition-all duration-100 hover:shadow-md"
                    style={{
                      background: 'rgba(52, 73, 94, 0.6)',
                      border: '1px solid rgba(241, 196, 15, 0.4)'
                    }}
                    onClick={() => window.open('https://console.cloud.google.com', '_blank')}
                  >
                    <div className="font-black" style={{color: '#ECF0F1'}}>☁️ Google Cloud Console</div>
                    <div className="text-sm font-bold" style={{color: '#F1C40F'}}>
                      Access Google Cloud Platform services
                    </div>
                  </button>
                </div>
              </div>
            </div>

            {/* System Health */}
            <div className="rounded-2xl p-1" style={{
              background: 'linear-gradient(135deg, rgba(231, 76, 60, 0.6), rgba(192, 57, 43, 0.6))',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
            }}>
              <div className="studio-card rounded-xl p-6" style={{
                background: 'rgba(52, 73, 94, 0.8)',
                border: 'none',
                backdropFilter: 'blur(10px)'
              }}>
                <h2 className="text-xl font-black tracking-wider mb-4" style={{
                  color: '#F1C40F',
                  textShadow: '1px 1px 0px #E67E22'
                }}>
                  🏥 SYSTEM HEALTH
                </h2>
                
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="font-bold" style={{color: '#ECF0F1'}}>Authentication Service</span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold" style={{
                      background: 'rgba(46, 204, 113, 0.2)',
                      color: '#2ECC71',
                      border: '1px solid rgba(46, 204, 113, 0.4)'
                    }}>
                      ● ONLINE
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-bold" style={{color: '#ECF0F1'}}>Firestore Database</span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold" style={{
                      background: 'rgba(46, 204, 113, 0.2)',
                      color: '#2ECC71',
                      border: '1px solid rgba(46, 204, 113, 0.4)'
                    }}>
                      ● ONLINE
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-bold" style={{color: '#ECF0F1'}}>Firebase Storage</span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold" style={{
                      background: 'rgba(46, 204, 113, 0.2)',
                      color: '#2ECC71',
                      border: '1px solid rgba(46, 204, 113, 0.4)'
                    }}>
                      ● ONLINE
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-bold" style={{color: '#ECF0F1'}}>Cloud Functions</span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold" style={{
                      background: 'rgba(46, 204, 113, 0.2)',
                      color: '#2ECC71',
                      border: '1px solid rgba(46, 204, 113, 0.4)'
                    }}>
                      ● ONLINE
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Warning Notice */}
        <div className="mt-8 studio-card rounded-xl p-4" style={{
          background: 'rgba(241, 196, 15, 0.1)',
          border: '2px solid rgba(241, 196, 15, 0.4)'
        }}>
          <div className="flex">
            <div className="flex-shrink-0">
              <ShieldCheckIcon className="h-5 w-5" style={{color: '#F1C40F'}} />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-black uppercase tracking-wider" style={{color: '#F1C40F'}}>
                ⚠️ ADMIN ACCESS NOTICE
              </h3>
              <div className="mt-2 text-sm">
                <p className="font-bold" style={{color: '#ECF0F1'}}>
                  You have administrative access to this system. Please use these tools responsibly. 
                  All actions are logged and monitored for security purposes. Contact system administrator 
                  if you encounter any issues or need additional permissions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 